export const imagePath = "https://d2w24n4g34usfg.cloudfront.net/SunWestPartners/images/"
export const videoPath = "https://d2w24n4g34usfg.cloudfront.net/SunWestPartners/videos/"